export default __webpack_public_path__ + "static/media/culture_EP12.1652a177.png";